import models from './index';

export const RECORD_CLASSES = {
  ...models,
  // Include other names
  'Ideas::Idea': models['Idea'],
  MasterRelease: models['Release'],
  StrategicImperative: models['Goal'],
};
